import { ComponentPropsWithoutRef } from "react";
import { twMerge } from "tailwind-merge";

/**
 * Inline clock icon painted with `currentColor`, so it follows the text color
 * of whatever tag/pill it sits in (the `icon-clock-*.svg` files are fixed-color
 * images and can't be recolored per status).
 */
export const ClockIcon = ({
  className,
  ...rest
}: ComponentPropsWithoutRef<"svg">) => (
  <svg
    {...rest}
    aria-hidden="true"
    viewBox="0 0 24 24"
    className={twMerge("shrink-0 fill-current", className)}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM11 7H12.5V12.25L17 14.92L16.25 16.15L11 13V7Z"
    />
  </svg>
);
